/// <reference path="../../../../app.definition.ts" />

import angular from "angular";
import 'angular-ui-bootstrap';
import { IAppRootScopeService } from "@/app/app.definition";
import { BroadcastService } from "@common/service/broadcast.service";
import { CacheService } from "@common/service/cache.service";

export class showReportController {

  static $inject = ['$rootScope', '$scope', '$uibModalInstance', 'CacheService', 'BroadcastService', 'params', 'subjectId', 'ecvId'];
  currentUserId: number;

  constructor(
    private $rootScope: IAppRootScopeService,
    private $scope: angular.IScope,
    private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
    private CacheService: CacheService,
    private BroadcastService: BroadcastService,
    private params: any,
    private subjectId: string,
    private ecvId: string
  ) {
    this.init();
  }

  init = () => {
    this.$rootScope.mainShowLoader = false;
    this.currentUserId = this.CacheService.getUser().id;
    this.BroadcastService.registerCallBack('dismiss-modal', this.$scope.$id, () => {
      this.dismiss()
    });
  }

  dismiss = () => {
    this.$uibModalInstance.dismiss();
    this.BroadcastService.removeCallBack('dismiss-modal', this.$scope.$id);
  }

  submit = () => {
    this.$uibModalInstance.dismiss();
  }
}

angular.module('eCareVault.common.analyticsReport')
  .controller('showReportController', showReportController);
